import ContactUs from "./ContactUs";
import DemandedJobs from "./DemandedJobs";
import FAQ from "../misc/FAQ";
import Footer from "./Footer";
import HowItWorks from "./HowItWorks";
import JobBenefits from "./JobBenefits";
import JobDescription from "./JobDescription";
import AboutUs from "../misc/AboutUs";
import Navbar from "../navigation/Navbar";
import InternshipCard from "../Internship/InternshipCard";
import InternshipsAPI from "../Apis/InternshipsAPI";
import ScrollableCards from "./ScrollableCards";
import BlogsAPI from "../Apis/BlogsAPI";
import HireTalentAPI from "../Apis/HireTalentAPI";
import FeaturesProvided from "./FeaturesProvided";
import Metrics from "./Metrics";
import FindProjectAPI from "../Apis/FindProjectAPI";

function Home() {
    return (
        <div>
            <Navbar></Navbar>
            <JobDescription></JobDescription>
            <Metrics></Metrics>
            <DemandedJobs></DemandedJobs>
            <FeaturesProvided/>
            <ScrollableCards title='Recently Posted Talents' subtitle='Hire for your works' talents={HireTalentAPI.fetchTalents(8, 0) || []} noOfCards={4} style={{background: '#FFF'}}/>
            <ScrollableCards title='Internships' subtitle='Choose Your Intership works' card={InternshipCard} talents={InternshipsAPI.fetchInternships()?.data || []} style={{background: '#FFF'}}/>
            <ScrollableCards title='Recently Posted Projects' subtitle='Hire for your works' talents={FindProjectAPI.fetchProjects(8, 0) || []} noOfCards={4} style={{background: '#FFF'}}/>
            <JobBenefits></JobBenefits>
            <HowItWorks></HowItWorks>
            <AboutUs></AboutUs>
            <FAQ></FAQ>
            <ScrollableCards title='Blogs' subtitle='Design, Art and Technologies. Read some fresh blogs' readMore={true} talents={BlogsAPI.fetchBlogs()?.data || []} />
            <ContactUs></ContactUs>
            <Footer></Footer>
        </div>
    );
}

export default Home;